import { Button, Dropdown } from "antd";
import * as APITypes from "~/API";
import { AccessRightStatusTag } from "~/components/Tags";

type AccessStatusDropdownProps = {
  currentStatus: APITypes.ResourceAccessRightStatus;
  onChange: (newStatus: APITypes.ResourceAccessRightStatus) => void;
  label: string;
  isLoading: boolean;
  isAdmin?: boolean;
};

export const AccessStatusDropdown = ({
  currentStatus,
  onChange,
  label,
  isLoading,
  isAdmin = false,
}: AccessStatusDropdownProps) => {
  // If status is already Granted, no dropdown should be shown
  if (
    currentStatus === APITypes.ResourceAccessRightStatus.Granted &&
    !isAdmin
  ) {
    return null;
  }

  // Admin users can change to any status
  // Non-admin users can only change to NotGranted or Requested
  const availableStatuses = isAdmin
    ? [
        APITypes.ResourceAccessRightStatus.NotGranted,
        APITypes.ResourceAccessRightStatus.Requested,
        APITypes.ResourceAccessRightStatus.Granted,
        APITypes.ResourceAccessRightStatus.Revoked,
      ]
    : [
        APITypes.ResourceAccessRightStatus.NotGranted,
        APITypes.ResourceAccessRightStatus.Requested,
      ];

  // Filter out the current status from available options
  const availableOptions = availableStatuses.filter(
    (status) => status !== currentStatus
  );

  // If no options are available, don't show the dropdown
  if (availableOptions.length === 0) {
    return null;
  }

  return (
    <Dropdown
      menu={{
        items: availableOptions.map((status) => ({
          key: status,
          disabled: isLoading,
          label: (
            <a
              onClick={(e) => {
                e.preventDefault();
                if (!isLoading) {
                  onChange(status);
                }
              }}
            >
              <AccessRightStatusTag status={status} />
            </a>
          ),
        })),
      }}
      placement="bottomLeft"
      disabled={isLoading}
    >
      <Button type="link" size="small" disabled={isLoading}>
        {label} ▼
      </Button>
    </Dropdown>
  );
};
